<ng-container *transloco="let t; prefix: 'scDeviceAuth'">
	<prism-dialog
		class="sh-dialog-container"
		data-testid="sh-single-device-auth-dialog"
		id="pwc-dialog"
		[visible]="true"
	>
		<div class="sh-content-container">
			@if (device(); as device) {
				<sh-device-image
					[deviceModel]="device.model"
					[isPasswordEnabled]="true"
					[isAuthenticated]="!!device.features.authentication?.authenticated"
					class="sh-device-image"
				></sh-device-image>
				<h1 class="sh-device-name" data-testid="sh-device-name">{{ device.name }}</h1>
				<h4 class="sh-device-ip-label">
					{{ device.features.controlNetwork?.ipAddress }}
				</h4>
			}

			<prism-input
				angular-input
				type="password"
				class="sh-dialog-password-input"
				data-testid="password-input"
				[formControl]="passwordInput"
				[isValid]="passwordInput.valid"
				(keydown.Enter)="onUnlockClick()"
			>
				<span slot="label">{{ t('common.labels.password') }}</span>
				<span slot="error-text">
					@if (!isAuthenticating) {
						@if (passwordInput.hasError('required')) {
							{{ t('common.errors.required') }}
						} @else if (passwordInput.hasError('invalidPassword')) {
							{{ t('common.errors.authenticate-device-password-error') }}
						} @else if (passwordInput.hasError('authFailed')) {
							{{ t('common.errors.authenticate-device-failed') }}
						}
					}
				</span>
			</prism-input>
		</div>

		<div slot="dialog-footer-buttons">
			@if (!preventCancelOnAuthPrompt) {
				<prism-button id="sh-single-device-auth-cancel-button" variant="text" (click)="onCancelClick()">
					{{ t('common.buttons.cancel') }}
				</prism-button>
			}

			@if (enableReadOnlyOption) {
				<prism-button
					id="sh-single-device-auth-read-only-button"
					variant="text"
					[disabled]="isAuthenticating"
					(click)="onReadOnlyClick()"
				>
					{{ t('common-device-password.read-only') }}
				</prism-button>
			}
			<prism-button
				id="sh-single-device-auth-unlock-button"
				data-testid="sh-single-device-auth-unlock-button"
				variant="text"
				[disabled]="!passwordInput.value?.length || isAuthenticating"
				(click)="onUnlockClick()"
			>
				@if (isAuthenticating) {
					<prism-progress-indicator
						type="circular"
						mode="indeterminate"
						value="0"
						size="sm"
					></prism-progress-indicator>
				} @else {
					{{ submitLabel ?? t('common.buttons.unlock') }}
				}
			</prism-button>
		</div>
	</prism-dialog>
</ng-container>
